// default are case sensitive
export const STRING_IS = '=='
export const STRING_IS_NOT = '!='
export const STRING_STARTS_WITH = 'startsWith'
export const STRING_ENDS_WITH = 'endsWith'
export const STRING_CONTAINS = 'contains'
export const STRING_DOES_NOT_CONTAIN = 'notIn'
export const STRING_IS_UNKNOWN = 'unknown'
export const STRING_ANY = 'any'

// Case insensitive
export const STRING_NC_IS = 'is_nc'
export const STRING_NC_IS_NOT = 'isNot_nc'
export const STRING_NC_STARTS_WITH = 'startsWith_nc'
export const STRING_NC_ENDS_WITH = 'endsWith_nc'
export const STRING_NC_CONTAINS = 'contains_nc'
export const STRING_NC_DOES_NOT_CONTAIN = 'notIn_nc'

export const stringOperators = Object.freeze({
    equalNc: {
        key: STRING_NC_IS,
        label: 'Is',
        json: {
            getLogic: (a, b) => ({
                [STRING_NC_IS]: [{'var': a}, b]
            }),
            getData: () => null
        }
    },
    equal: {
        key: STRING_IS,
        label: 'Is (match case)',
        json: {
            getLogic: (a, b) => ({
                [STRING_IS]: [{'var': a}, b]
            }),
            getData: () => null
        }

    },
    notEqualNc: {
        key: STRING_NC_IS_NOT,
        label: 'Is not',
        json: {
            getLogic: (a, b) => ({
                [STRING_NC_IS_NOT]: [{'var': a}, b]
            }),
            getData: () => null
        }
    },
    notEqual: {
        key: STRING_IS_NOT,
        label: 'Is not (match case)',
        json: {
            getLogic: (a, b) => ({
                [STRING_IS_NOT]: [{'var': a}, b]
            }),
            getData: () => null
        }
    },
    startsWithNc: {
        key: STRING_NC_STARTS_WITH,
        label: 'Starts with',
        json: {
            getLogic: (a, b) => ({
                [STRING_NC_STARTS_WITH]: [{'var': a}, b]
            }),
            getData: () => null
        }
    },
    startsWith: {
        key: STRING_STARTS_WITH,
        label: 'Starts with (match case)',
        json: {
            getLogic: (a, b) => ({
                [STRING_STARTS_WITH]: [{'var': a}, b]
            }),
            getData: () => null
        }
    },
    endsWithNc: {
        key: STRING_NC_ENDS_WITH,
        label: 'Ends with',
        json: {
            getLogic: (a, b) => ({
                [STRING_NC_ENDS_WITH]: [{'var': a}, b]
            }),
            getData: () => null
        }
    },

    endsWith: {
        key: STRING_ENDS_WITH,
        label: 'Ends with (match case)',
        json: {
            getLogic: (a, b) => ({
                [STRING_ENDS_WITH]: [{'var': a}, b]
            }),
            getData: () => null
        }
    },
    containsNc: {
        key: STRING_NC_CONTAINS,
        label: 'Contains',
        json: {
            getLogic: (a, b) => ({
                [STRING_NC_CONTAINS]: [{'var': a}, b]
            }),
            getData: () => null
        }
    },
    contains: {
        key: STRING_CONTAINS,
        label: 'Contains (match case)',
        json: {
            getLogic: (a, b) => ({
                [STRING_CONTAINS]: [{'var': a}, b]
            }),
            getData: () => null
        }
    },
    doesNotContainNc: {
        key: STRING_NC_DOES_NOT_CONTAIN,
        label: 'Does not contain',
        json: {
            getLogic: (a, b) => ({
                [STRING_NC_DOES_NOT_CONTAIN]: [{'var': a}, b]
            }),
            getData: () => null
        }
    },
    doesNotContain: {
        key: STRING_DOES_NOT_CONTAIN,
        label: 'Does not contain (match case)',
        json: {
            getLogic: (a, b) => ({
                [STRING_DOES_NOT_CONTAIN]: [{'var': a}, b]
            }),
            getData: () => null
        }
    },
    unknown: {
        key: STRING_IS_UNKNOWN,
        label: 'Is unknown',
        json: {
            getLogic: (a, b) => ({
                [STRING_IS_UNKNOWN]: [{'var': a}, b]
            }),
            getData: () => null
        }
    },
    any: {
        key: STRING_ANY,
        label: 'Has any value',
        json: {
            getLogic: (a, b) => ({
                [STRING_ANY]: [{'var': a}, b]
            }),
            getData: () => null
        }
    }
})

export const checkIsCaseSensitiveOperator = key => [
    STRING_IS,
    STRING_IS_NOT,
    STRING_STARTS_WITH,
    STRING_ENDS_WITH,
    STRING_CONTAINS,
    STRING_DOES_NOT_CONTAIN,
    STRING_IS_UNKNOWN,
    STRING_ANY
].includes(key)

export const stringOperatorsList = Object.freeze(Object.values(stringOperators))
